export function doStyleFixedBubbles() {
    $(`
        <div class="fixed-bubble-wrapper move-up hidden">
            <div class="icon"></div>
        </div>
        <div class="fixed-bubble-wrapper chat">
            <div class="icon"></div>
        </div>
    `).appendTo('.overall-wrapper');

    const $moveUp = $('.fixed-bubble-wrapper.move-up');
    window.onscroll = function doStickyNavigation() {
        if(window.pageYOffset > 800) {
            $moveUp.removeClass('hidden');
        } else {
            $moveUp.addClass('hidden');
        }
    }

    $moveUp.click(function () {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    })
}
